(function () {
  async function loadSwiperOnce() {
    if (window.Swiper) return;

    if (!document.querySelector('link[data-adv-swiper-css]')) {
      const css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
      css.setAttribute('data-adv-swiper-css', 'true');
      document.head.appendChild(css);
    }

    if (!document.querySelector('script[data-adv-swiper-js]')) {
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      script.setAttribute('data-adv-swiper-js', 'true');
      document.head.appendChild(script);

      await new Promise((resolve) => (script.onload = resolve));
    } else if (!window.Swiper) {
      await new Promise((resolve) => {
        const t = setInterval(() => {
          if (window.Swiper) {
            clearInterval(t);
            resolve();
          }
        }, 30);
      });
    }
  }

  if (!customElements.get('advanced-tabbed-slider')) {
    class AdvancedTabbedSlider extends HTMLElement {
      constructor() {
        super();
        this._initialized = false;
      }

      async connectedCallback() {
        // In Shopify editor, section HTML can be re-rendered; allow re-init
        if (this._initialized) return;
        this._initialized = true;

        // Wait 1 frame so inner HTML is definitely present (important in injected sections)
        await new Promise((r) => requestAnimationFrame(r));

        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.viewsDesktop = parseInt(this.dataset.desktopViews, 10) || 3;
        this.viewsMobile = parseInt(this.dataset.mobileViews, 10) || 2;

        this.setupTabs();
        this.setupCartForms();

        await loadSwiperOnce();
        this.initActiveSwiper();
      }

      getActivePanel() {
        return this.querySelector('[role="tabpanel"]:not([hidden])');
      }

      initActiveSwiper() {
        const activePanel = this.getActivePanel();
        if (!activePanel) return;

        const container = activePanel.querySelector('[data-swiper-container]');
        if (!container || container.swiper) return;

        new window.Swiper(container, {
          slidesPerView: this.viewsMobile,
          spaceBetween: 10,
          navigation: {
            nextEl: activePanel.querySelector('.swiper-button-next'),
            prevEl: activePanel.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: activePanel.querySelector('.swiper-pagination'),
            clickable: true,
          },
          breakpoints: {
            768: { slidesPerView: this.viewsDesktop, spaceBetween: 18 },
          },
        });
      }

      setupTabs() {
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.switchTab(tab));
        });
      }

      switchTab(selectedTab) {
        this.tabs.forEach((tab) => {
          const isSelected = tab === selectedTab;
          tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          tab.tabIndex = isSelected ? 0 : -1;
        });

        const targetPanelId = selectedTab.getAttribute('aria-controls');
        this.panels.forEach((panel) => {
          panel.hidden = panel.id !== targetPanelId;
        });

        setTimeout(() => this.initActiveSwiper(), 30);
      }

      setupCartForms() {
        this.querySelectorAll('[data-advanced-cart-form]').forEach((form) => {
          form.addEventListener('submit', this.handleCartSubmit.bind(this));
        });
      }

      async handleCartSubmit(e) {
        e.preventDefault();
        const form = e.target;

        const submitBtn = form.querySelector('button[name="add"]');
        const textSpan = submitBtn.querySelector('.adv-btn__text');
        const spinner = submitBtn.querySelector('.adv-btn__spinner');
        const errorDiv = form.querySelector('.adv-card__error');

        submitBtn.disabled = true;
        textSpan.hidden = true;
        spinner.hidden = false;
        errorDiv.hidden = true;

        try {
          const formData = new FormData(form);
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: formData,
          });

          const data = await response.json();
          if (!response.ok || data.status >= 400) throw new Error(data.description || 'Sold out or error');

          textSpan.textContent = 'Added';
        } catch (error) {
          errorDiv.textContent = error.message;
          errorDiv.hidden = false;
          textSpan.textContent = 'Error';
        } finally {
          spinner.hidden = true;
          textSpan.hidden = false;
          setTimeout(() => {
            submitBtn.disabled = false;
            textSpan.textContent = 'Add to cart';
          }, 1600);
        }
      }
    }

    customElements.define('advanced-tabbed-slider', AdvancedTabbedSlider);
  }

  // Shopify theme editor: when a section is reloaded, allow re-init
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('advanced-tabbed-slider').forEach((el) => {
      el._initialized = false;
      el.connectedCallback();
    });
  });
})();
